import { __assign, __makeTemplateObject, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { color } from '@metro-ui/tokens/js';
import { onChangeCheckedHandler, } from '../shared/eventHandler';
import { Icon, iconClass } from './components/Icon';
import { Input, inputClass } from './components/Input';
import { Label } from '../Label';
export var Checkbox = React.forwardRef(function (_a, ref) {
    var id = _a.id, name = _a.name, isChecked = _a.isChecked, onChange = _a.onChange, onClick = _a.onClick, isDisabled = _a.isDisabled, hasError = _a.hasError, children = _a.children, label = _a.label, className = _a.className, htmlAttributes = __rest(_a, ["id", "name", "isChecked", "onChange", "onClick", "isDisabled", "hasError", "children", "label", "className"]);
    return (
    // eslint-disable-next-line jsx-a11y/label-has-for
    React.createElement(Label, { className: className, onClick: onClick, htmlFor: id, isDisabled: isDisabled },
        React.createElement(Input, __assign({}, htmlAttributes, { className: inputClass, type: "checkbox", onChange: onChangeCheckedHandler(onChange), id: id, disabled: isDisabled, name: name, ref: ref, checked: !!isChecked, "aria-label": label })),
        React.createElement(Icon, { className: iconClass, isChecked: isChecked, isDisabled: isDisabled, hasError: hasError }),
        !!children && React.createElement("span", null, children)));
});
export var CheckboxOld = styled(function (_a) {
    var id = _a.id, name = _a.name, isChecked = _a.isChecked, onChange = _a.onChange, onClick = _a.onClick, isDisabled = _a.isDisabled, hasError = _a.hasError, children = _a.children, className = _a.className, htmlAttributes = __rest(_a, ["id", "name", "isChecked", "onChange", "onClick", "isDisabled", "hasError", "children", "className"]);
    return (
    // eslint-disable-next-line jsx-a11y/label-has-for
    React.createElement(Label, { className: className, onClick: onClick, htmlFor: id, isDisabled: isDisabled },
        React.createElement(Input, __assign({}, htmlAttributes, { className: inputClass, type: "checkbox", onChange: onChangeCheckedHandler(onChange), id: id, disabled: isDisabled, name: name, checked: !!isChecked })),
        React.createElement(Icon, { className: iconClass, isChecked: isChecked, isDisabled: isDisabled, hasError: hasError }),
        !!children && React.createElement("span", null, children)));
})(function (_a) {
    var isChecked = _a.isChecked, hasError = _a.hasError;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    cursor: pointer;\n\n    &:hover {\n      .", ":not(:disabled) + .", " {\n        border-color: ", ";\n      }\n    }\n  "], ["\n    display: flex;\n    cursor: pointer;\n\n    &:hover {\n      .", ":not(:disabled) + .", " {\n        border-color: ", ";\n      }\n    }\n  "])), inputClass, iconClass, isChecked !== undefined && hasError
        ? color.danger
        : color.interaction);
});
Checkbox.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
    isChecked: PropTypes.bool,
    isDisabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onClick: PropTypes.func,
    label: PropTypes.string,
    className: PropTypes.string,
};
var templateObject_1;
//# sourceMappingURL=Checkbox.js.map